














import { Component, Vue, Prop } from 'vue-property-decorator';
import { getFileData } from '@/utils';

@Component({
  name: 'upload',
})
export default class Upload extends Vue {
  @Prop(Boolean) disabled!: boolean;

  @Prop({ type: String, default: '' }) accept!: string;

  @Prop({ type: Boolean, default: false }) multiple!: boolean;

  dragover = false;

  onClick() {
    const el = this.$refs.input as HTMLInputElement | undefined;
    if (!el) {
      return;
    }
    el.click();
    this.$nextTick(() => {
      el.value = '';
    });
    // el.value = '';
  }

  onChange(event: Event) {
    this.$nextTick(() => {
      const { files } = event.target as HTMLInputElement;
      if (files) {
        this.$emit('files', Array.from(files));
      }
    });
  }

  onDragover() {
    if (!this.disabled) {
      this.dragover = true;
    }
  }

  onDrop(event: DragEvent) {
    if (this.disabled) return;

    this.dragover = false;
    if (event.dataTransfer === null) return;
    const files = getFileData(event.dataTransfer, this.accept, this.multiple);
    this.$emit('files', files);
  }
}
